import cn from 'classnames';
import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { Link } from 'shared/ui/Link';
import { Map, Placemark } from '@pbe/react-yandex-maps';
import {
    Icon,
    IconsNames,
    Image,
} from 'shared';
// eslint-disable-next-line no-restricted-imports
import { LeadForm } from 'features/lead/ui/form';
import {
    Box,
    Flex,
    Grid,
    Text,
} from '@chakra-ui/react';
import styles from './ContactsBlock.module.scss';
import { useContactsBlockState } from '../model';

export type ContactsBlockProps = {
    className?: string
}

export const ContactsBlock = ({
    className,
}: ContactsBlockProps) => {
    const {
        phone,
        email,
        address,
        socialMedias,
    } = useContactsBlockState();

    return (
        <Grid
            background="#000000"
        >
            <Flex
                className={cn(className, styles.contactsBlock)}
                maxWidth={{
                    base: '425px',
                    lg: '1280px',
                }}
                flexDirection={{
                    base: 'column',
                    lg: 'row',
                }}
                width="100%"
                margin="0 auto"
            >
                <LeadForm
                    className={styles.contactsBlock__leadForm}
                    title="ЕЩЕ ОСТАЛИСЬ ВОПРОСЫ?"
                    subtitle="Напишите сейчас и мы поможем их решить"
                    hasTextArea
                />
                <Box
                    className={styles.contactsBlock__divider}
                    width={{
                        base: 'auto',
                        lg: '3px',
                    }}
                    height={{
                        base: '3px',
                        lg: 'auto',
                    }}
                />
                <div className={styles.contactsBlock__infoSection}>
                    <span className={styles.contactsBlock__title}>
                        Контакты
                    </span>
                    <div className={styles.contactsBlock__contacts}>
                        <div className={styles.iconText}>
                            <Icon iconName={IconsNames.Phone} />
                            <span>
                                {phone}
                            </span>
                        </div>
                        <div className={styles.iconText}>
                            <Icon iconName={IconsNames.Mail} />
                            <span>
                                {email}
                            </span>
                        </div>
                    </div>
                    <Text
                        className={styles.contactsBlock__title}
                        lineHeight={1}
                    >
                        Мы в социальных сетях
                    </Text>
                    <div className={styles.contactsBlock__socialMedias}>
                        {socialMedias.map(({ image, link }) => (
                            <Link
                                to={link}
                            >
                                <Box
                                    background="white"
                                    padding="0.5rem"
                                >
                                    <Image
                                        src={image.url}
                                        aspectRatio="1/ 1"
                                        objectFit="contain"
                                        width="3rem"
                                        height="3rem"
                                        margin="auto 0 0 0"
                                    />
                                </Box>
                            </Link>
                        ))}
                    </div>
                    <Text
                        className={styles.contactsBlock__title}
                        lineHeight={1}
                    >
                        Как до нас добраться
                    </Text>
                    <div className={styles.contactsBlock__address}>
                        <div className={styles.iconText}>
                            <Icon iconName={IconsNames.Map} />
                            <span>
                                {address?.name}
                            </span>
                        </div>
                        <div className={styles.contactsBlock__mapWrapper}>
                            {address && (
                                <Map
                                    className={styles.contactsBlock__map}
                                    defaultState={{
                                        center: [address.latitude, address.longitude],
                                        zoom: 17,
                                    }}
                                >
                                    <Placemark
                                        geometry={[address.latitude, address.longitude]}
                                    />
                                </Map>
                            )}
                            <div className={styles.contactsBlock__mapDivider}>
                                <div />
                                <span>НАШ АДРЕС</span>
                            </div>
                        </div>
                    </div>
                </div>
            </Flex>
        </Grid>
    );
};
